import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var PreviewIllustration = function PreviewIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "PreviewIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M56 11c-30.833 0-37 25-37 25s6.167 25 37 25 37-25 37-25-6.167-25-37-25",
      opacity: ".3"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M56.075 49.148c7.22 0 13.073-5.854 13.073-13.074S63.295 23 56.075 23 43 28.853 43 36.074c0 7.22 5.853 13.074 13.074 13.074",
      opacity: ".15"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      fillRule: "evenodd",
      d: "M71.517 47.27a19 19 0 0 0 3.63-11.196C75.148 25.54 66.608 17 56.075 17S37 25.54 37 36.074s8.54 19.074 19.074 19.074c4.185 0 8.056-1.349 11.201-3.635l8.59 8.59a3 3 0 1 0 4.242-4.243zm-15.443 1.878c7.22 0 13.074-5.854 13.074-13.074S63.294 23 56.074 23 43 28.853 43 36.074c0 7.22 5.853 13.074 13.074 13.074",
      clipRule: "evenodd",
      opacity: ".5"
    })]
  }));
};

export { PreviewIllustration };
